module.exports = __webpack_public_path__ + "static/media/P-5-pre-sch-teacher.56731ffd.jpg";